import axios from "axios"
import "../Stylesheets/Login/Login.css"
import { useState } from "react"
import { useDispatch } from "react-redux";
import { usersActions } from "../store/user";

const Login = ({setNotification}) => {
    const [formData, setFormData] = useState({username: "", password: ""});
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    

    const handlers = {
        auth(e){
            e.preventDefault();
            setLoading(true);
            !loading && axios.post('/api/extension/v1/users/login', formData)
                .then((res) => {
                    setNotification({show: true, type: "success", text: "You are logged in"});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    dispatch(usersActions.changeIsLoggedIn(true));
                    dispatch(usersActions.saveUserData(res.data.data));
                    setLoading(false);
                })
                .catch((err) => {
                    dispatch(usersActions.changeIsLoggedIn(false));
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoading(false);
                })
        }
    }

    return(
        <div className="login-page-container">
            <div className="login-page-banner">

            </div>
            <div className="login-form-container">
                <h2>Welcome to Automarket</h2>
                <form className="login-form" onSubmit={handlers.auth}>
                    <div className="form-group">
                        <label>Username:</label>
                        <input type="text" className="form-control" name="username" value={formData.username} onChange={(e) => setFormData((prev) => ({...prev, username: e.target.value}))}/>
                    </div>
                    <div className="form-group">
                        <label>Password:</label>
                        <input type="password" name="password" className="form-control" value={formData.password} onChange={(e) => setFormData((prev) => ({...prev, password: e.target.value}))}/>
                    </div>
                    <button className="login-button" type="submit">{loading ? <div className="button-loader"></div> : "Log In"}</button>
                </form>
            </div>
        </div>
    )
}

export default Login